// extracted by mini-css-extract-plugin
export default {"card":"ProductCard_card__kcyA+","image":"ProductCard_image__QjhHx","cardName":"ProductCard_cardName__ksvfM"};